import {getType, resolveIdentifier, types} from "mobx-state-tree";
import CodeType from "../../../models/CodeType";
import CodeTypeStore from "../../../stores/domain/CodeTypeStore";
import Notification from "../../../utils/Notification";
import {codeBehavior} from "../../../utils/constants";
import {DimensionValues} from "../../../models/Dimension";
import lodash from "lodash";


export const CodeTypeSelectState = types.model('CodeTypeSelectState',{
  selectStateUuid: types.identifier,
  store: types.maybe(types.late(() => types.reference(CodeTypeStore))),
  selected: types.maybe(types.safeReference(CodeType)),
  readonly: types.optional(types.boolean, false),
  isEditMode: types.optional(types.boolean, false),
  selectedCodeTypes: types.maybe(types.array(types.safeReference(CodeType))),
}).volatile(self => ({
  notifySelect: types.function,
  notifyMultiSelect: types.function,
  fsm: types.function,
  // selectedSchema: types.object
})).actions((self)=>({
  search(txt){
    //self.groupOptions = self.groupStore.searchFor(txt)
    //self.groupStore.groups
  },
  setConsumer(f){
    self.notifySelect = f
  },
  setMultiSelectConsumer(f) {
    self.notifyMultiSelect = f
  },
  setDefaultCodeType(codeType) {
    self.notifySelect(codeType)
    self.selected = codeType;
  },
  setEditMode(mode) {
    self.isEditMode = mode;
  },
  setSecondary(isSecondary) {
    self.isSecondary = isSecondary;
  },
  setFsm(fsm) {
    self.fsm = fsm;
  },
  returnDynamic(behavior) {
    const filteredBehavior = behavior?.filter(b => b !== codeBehavior.STATIC);
    if(filteredBehavior?.length === 1) {
      return filteredBehavior[0];
    } else {
      return "";
    }
  },
  execute(codeType) {
    if(self.fsm) {
      const targetTransition = codeType.uuid + "|" +self.returnDynamic(codeType.behavior)
      return !!self.fsm.can(targetTransition);
    }
  },
  select(codeType) {
    if(self.isEditMode) {
      if(self.execute(codeType)) {
        if(lodash.isArray(codeType)) {
          self.selectedCodeTypes = codeType?.map(d => {
            return resolveIdentifier(CodeType, self, d?.uuid || d)
          })
          self.notifyMultiSelect(self.selectedCodeTypes)
        }
        else {
          self.notifySelect(codeType)
          self.selected = codeType
        }
      } else {
        new Notification()
          .setType("error")
          .setMessage(`GS1 codes cannot be altered and converting other types to GS1 or static codes is not allowed. The selected code type is ${codeType.name} with behavior ${codeType.behavior}.`)
          .send();
      }
    } else {
      console.log(codeType)
      if(lodash.isArray(codeType)) {
        self.selectedCodeTypes = codeType?.map(d => {
          return resolveIdentifier(CodeType, self, d?.uuid || d)
        })
        if(lodash.isEmpty(codeType)){
          self.selectedCodeTypes = undefined
        }
        self.notifyMultiSelect(self.selectedCodeTypes)
      }
      else {
        const allowSelection = self.notifySelect(codeType)
        // Only update selection if the consumer allows it (returns true or undefined)
        if (allowSelection !== false) {
          self.selected = codeType
        }
      }
      console.log(self.selectedSchema)
    }
  },
  clear(){
    self.selectedCodeTypes = undefined
  },
  initDefaults(){
    //the url is the default type for every tenant.
    const codeTypes = self.store.codeTypes || [];
    const urlType = codeTypes.find(codeType => codeType.name === 'url');
    const defaultType = urlType || codeTypes[0];
    self.select(defaultType);
    // self.store.codeTypes.forEach((codeType) => {
    //   if (codeType.name ==='url') {
    //     self.select(codeType);
    //   }
    // })
  },
  afterCreate() {
    console.log("Instantiated " + getType(self).name)
    self.notifySelect = (data) => { //TODO
      console.log("placeholder notifySelect")
    }

    self.selectedSchema = {}

  }

})).views( (self) => ({
  options() {
    const { codeTypes } = self.store || [];
    return codeTypes.slice().sort((a,b)=> a?.label?.localeCompare(b?.label))
  },
  secondaryOptions() {
    const { codeTypes } = self.store || [];
    return codeTypes.filter(codeType => codeType.uuid === 'url');
  }
  // selectedSchemaView(){
  //   return JSON.parse(self.selectedSchema)
  // }
}))
